<p-toast position="top-right"></p-toast>
<div class="purchase-ORDERS p-g-12">
   <div class="p-g-12">
      <p-tabView [activeIndex]="tabIndex" (onChange)="handleTabChange($event)">
         <p-tabPanel [header]='setLabel("unfulfilledLabel")' leftIcon="fa fa-times">
            <div class="p-g">
               <div class="p-g-12 p-table-tecfolk-fix">
                  <p-table [value]="unFulFilledPurchases" [paginator]="true" [rows]="10" [responsive]="true"
                     [loading]="loading" [first]="firstUnFulFilled" (onPage)="onUnfulfilledPageChange($event)">

                     <ng-template pTemplate="caption" style="text-align: left">
                        <div class="reportMainFilter">
                           <div class="reportMainFields">
                              <div class="filterFields">
                                 <span class="fieldTitle">{{setLabel("searchByOrderNumberLabel")}}</span>
                                 <input id="searchOrder" #searchOrder autocomplete="off" pinputtext=""
                                    (keyup)="searchLocalUnFulFilled(purchaseOrder.purchaseOrderNumber, 'number')"
                                    [(ngModel)]="purchaseOrder.purchaseOrderNumber"
                                    [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                                    class="p-inputtext p-corner-all p-state-default p-widget">
                              </div>
                              <div class="reportMainBtn">
                                 <span [pTooltip]='setLabel("clearSearchPtooltipLabel")' tooltipPosition="top" class="iconClear"
                                    [disabled]="loading" (click)="clearUnfulfilled()"> <i
                                       class="pi pi-times"></i></span>
                              </div>
                           </div>
                           <div class="reportMainBtn">
                              <span [pTooltip]='setLabel("clearSearchPtooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop"
                                 [disabled]="loading" (click)="clearUnfulfilled()"> <i class="pi pi-times"></i></span>
                              <!-- <button (click)="clearUnfulfilled()"
                                 class="Clear-Search p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                    class="fa fa-eraser"></i>&nbsp;Clear
                                 Search
                              </button> -->
                              <span [pTooltip]='setLabel("addNewPtooltipLabel")' tooltipPosition="top"
                                 routerLink="/purchase-order" class="iconClear " [disabled]="loading"> <i
                                    class="pi pi-user-plus"></i></span>
                              <!-- <button routerLink="/purchase-order"
                                 class="New p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                                 <i class="fa fa-plus"></i>&nbsp;
                                 New
                                 <span class="F2"> (F2)</span>
                              </button> -->
                           </div>
                        </div>
                     </ng-template>

                     <ng-template pTemplate="header">
                        <tr>
                           <th style="max-width: 90px;">{{setLabel("orderNumberLabel")}}</th>
                           <th style="max-width: 90px;">{{setLabel("createdDateLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("supplierLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("supplierContactLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("remarksLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("actionsLabel")}}</th>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="body" let-rowData>
                        <tr class="tr">
                           <td style="padding-left: 3%;">

                              <div class="mobile-Lable">{{setLabel("orderNumberLabel")}}</div>
                              {{rowData.purchaseOrderNumber}}
                           </td>
                           <td>

                              <div class="mobile-Lable">{{setLabel("createdDateLabel")}}</div>
                              {{rowData.purchaseOrderDate | date: 'd/M/yy, h:mm a'}}
                           </td>
                           <td>

                              <div class="mobile-Lable">{{setLabel("supplierLabel")}}</div>
                              {{rowData.supplier.name}}
                           </td>
                           <td>

                              <div class="mobile-Lable">{{setLabel("supplierContactLabel")}}</div>
                              {{rowData.supplier.phone}}
                           </td>

                           <td (click)="ShowCommentBox(rowData)"
                              [ngClass]="rowData.remarks === undefined ? '' : 'commentSectionHighlight'">

                              <div class="mobile-Lable">{{setLabel("remarksLabel")}}</div>


                              <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                                 *ngIf="rowData.remarks !== '' && rowData.remarks != undefined; else emptyComment">
                                 {{rowData.remarks}}
                              </div>

                              <ng-template #emptyComment>
                                 <span style="font-family: 'FontAwesome';">
                                    {{setLabel("noRemarksLabel")}}
                                 </span>
                              </ng-template>
                           </td>

                           <td>

                              <div class="mobile-Lable">{{setLabel("actionsLabel")}}</div>

                              <button pButton type="button" [pTooltip]='setLabel("deactivateOrderPtooltipLabel")'
                                 tooltipPosition="top" style="margin-right: 5px;" class="p-button-danger p-button"
                                 icon="fa fa-times" (click)="deleteUnFulfilledPurchaseOrder(rowData)">
                              </button>
                              <button pButton type="button" [pTooltip]='setLabel("editOrderDetailsPtooltipLabel")'
                                 tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="viewPurchaseOrder(rowData)"
                                 style="margin-right: 5px;">
                              </button>
                           </td>

                        </tr>
                     </ng-template>

                     <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                           <td>
                              {{setLabel("noRecordFoundLabel")}}
                           </td>
                        </tr>
                     </ng-template>
                  </p-table>
               </div>
            </div>
         </p-tabPanel>

         <p-tabPanel [header]='setLabel("fulfilledLabel")' leftIcon="fa fa-check">
            <div class="p-g">

               <div class="p-g-12 p-table-tecfolk-fix">
                  <p-table [value]="fulFilledPurchases" [paginator]="true" [rows]="10" [responsive]="true"
                     [loading]="loading" [first]="firstFulFilled" (onPage)="onFulfilledPageChange($event)">

                     <ng-template pTemplate="caption" style="text-align: left">
                        <div class="reportMainFilter">
                           <div class="reportMainFields">
                              <div class="filterFields">
                                 <span class="fieldTitle">{{setLabel("searchByOrderNumberLabel")}}</span>
                                 <input id="searchOrder" #searchOrder autocomplete="off" pinputtext=""
                                    (keyup)="searchLocalFulfilled(purchaseOrder.purchaseOrderNumber, 'number')"
                                    [(ngModel)]="purchaseOrder.purchaseOrderNumber"
                                    [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                                    class="p-inputtext p-corner-all p-state-default p-widget">
                              </div>
                              <div class="reportMainBtn">
                                 <span [pTooltip]='setLabel("clearSearchPtooltipLabel")' tooltipPosition="top" class="iconClear"
                                    [disabled]="loading" (click)="clearFulfilled()"> <i class="pi pi-times"></i></span>
                              </div>
                           </div>
                           <div class="reportMainBtn">
                              <span [pTooltip]='setLabel("clearSearchPtooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop"
                                 [disabled]="loading" (click)="clearFulfilled()"> <i class="pi pi-times"></i></span>
                              <span [pTooltip]='setLabel("addNewPtooltipLabel")' tooltipPosition="top"
                                 routerLink="/purchase-order" class="iconClear " [disabled]="loading"> <i
                                    class="pi pi-user-plus"></i></span>
                           </div>
                        </div>
                        <!-- <div class="Fulfilled">
                           <div>
                              <input id="searchOrder" #searchOrder autocomplete="off" pinputtext=""
                                 (keyup)="searchLocalFulfilled(purchaseOrder.purchaseOrderNumber, 'number')"
                                 [(ngModel)]="purchaseOrder.purchaseOrderNumber" placeholder="Search By Order Number"
                                 type="text" name="name" class="fulfilled-Search-Order ng-pristine ng-valid ng-touched">
                           </div>
                           <div class="btn-Main">
                              <button (click)="clearFulfilled()"
                                 class="fulfilled-Clear-Search p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                    class="fa fa-eraser"></i>&nbsp;Clear
                                 Search
                              </button>

                              <button routerLink="/purchase-order"
                                 class="fulfilled-New p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                                 <i class="fa fa-plus"></i>&nbsp;
                                 New
                                 <span class="fulfilled-F2"> (F2)</span>
                              </button>
                           </div>
                        </div> -->



                     </ng-template>

                     <ng-template pTemplate="header">
                        <tr>
                           <th style="max-width: 90px;">{{setLabel("orderNumberLabel")}}</th>
                           <th style="max-width: 90px;">{{setLabel("createdDateLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("supplierLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("supplierContactLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("remarksLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("actionsLabel")}}</th>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="body" let-rowData>
                        <tr class="tr">
                           <td style="padding-left: 3%;">
                              <div class="mobile-Lable-Fullfilled">{{setLabel("orderNumberLabel")}}</div>
                              {{rowData.purchaseOrderNumber}}
                           </td>
                           <td>
                              <div class="mobile-Lable-Fullfilled">{{setLabel("createdDateLabel")}}</div>
                              {{rowData.purchaseOrderDate | date: 'd/M/yy, h:mm a'}}
                           </td>
                           <td>
                              <div class="mobile-Lable-Fullfilled">{{setLabel("supplierLabel")}}</div>
                              {{rowData.supplier.name}}
                           </td>
                           <td>
                              <div class="mobile-Lable-Fullfilled">{{setLabel("supplierContactLabel")}}</div>
                              {{rowData.supplier.phone}}
                           </td>

                           <td (click)="ShowCommentBox(rowData)"
                              [ngClass]="rowData.remarks === undefined ? '' : 'commentSectionHighlight'">
                              <div class="mobile-Lable-Fullfilled">{{setLabel("remarksLabel")}}</div>


                              <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                                 *ngIf="rowData.remarks !== '' && rowData.remarks != undefined; else emptyComment">
                                 {{rowData.remarks}}
                              </div>

                              <ng-template #emptyComment>
                                 <span style="font-family: 'FontAwesome';">
                                    {{setLabel("noRemarksLabel")}}
                                 </span>
                              </ng-template>
                           </td>

                           <td>
                              <div class="mobile-Lable-Fullfilled">{{setLabel("actionsLabel")}}</div>

                              <button pButton type="button" [pTooltip]='setLabel("deactivateOrderPtooltipLabel")'
                                 tooltipPosition="top" style="margin-right: 5px;" class="p-button-danger p-button"
                                 icon="fa fa-times" (click)="deleteFulfilledPurchaseOrder(rowData)">
                              </button>
                              <button pButton type="button" [pTooltip]='setLabel("editOrderDetailsPtooltipLabel")'
                                 tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="viewPurchaseOrder(rowData)"
                                 style="margin-right: 5px;">
                              </button>
                           </td>

                        </tr>
                     </ng-template>

                     <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                           <td>
                              {{setLabel("noRecordFoundLabel")}}
                           </td>
                        </tr>
                     </ng-template>

                  </p-table>
               </div>
            </div>
         </p-tabPanel>

      </p-tabView>

      <!-- <div class="card card-w-title">

         <div class="p-g">
            <div class="p-g-6">
               <h1 style="margin-top: 0px;">Purchase Orders</h1>
            </div>
            <div class="p-g-6">
            </div>
         </div>

         <div>
            <p-table [value]="purchases" [paginator]="true" [rows]="10" [responsive]="true" [loading]="loading"
               [first]="first" (onPage)="onPageChange($event)">

               <ng-template pTemplate="caption" style="text-align: left">
                  <input id="searchOrder" #searchOrder
                     style=" color: black ; height:30px ;outline: none; box-shadow: none; margin-right: 8px; width: 18%;"
                     autocomplete="off" pinputtext="" (keyup)="searchLocal(purchaseOrder.purchaseOrderNumber, 'number')"
                     [(ngModel)]="purchaseOrder.purchaseOrderNumber" placeholder="Search By Order Number" type="text"
                     name="name" class="ng-pristine ng-valid ng-touched">

                  <button style="background: #ffffff; color: #0e2031; margin-right: 8px;" (click)="clear()"
                     class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                        class="fa fa-eraser"></i>&nbsp;Clear
                     Search
                  </button>

                  <button routerLink="/purchase-order" style="background-color: #5192d0; margin-right: 8px;"
                     class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                     <i class="fa fa-plus"></i>&nbsp;
                     New
                     <span style="font-family: none;font-size: small;"> (F2)</span>
                  </button>

               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">Order Number</th>
                     <th style="max-width: 90px;">Created Date</th>
                     <th style="max-width: 130px;">Supplier</th>
                     <th style="max-width: 130px;">Supplier Contact</th>
                     <th style="max-width: 130px; padding-left: 76px;">Remarks</th>
                     <th style="max-width: 130px; text-align: center;">Actions</th>
                  </tr>
               </ng-template>

               <ng-template pTemplate="body" let-rowData>
                  <tr>
                     <td style="padding-left: 3%;">{{rowData.purchaseOrderNumber}}</td>
                     <td>{{rowData.purchaseOrderDate | date: 'd/M/yy, h:mm a'}}</td>
                     <td>{{rowData.supplier.name}}</td>
                     <td>{{rowData.supplier.phone}}</td>

                     <td (click)="ShowCommentBox(rowData)" style="text-align: center;"
                        [ngClass]="rowData.remarks === undefined ? '' : 'commentSectionHighlight'">

                        <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" *ngIf="rowData.remarks !== '' && rowData.remarks != undefined; else emptyComment">
                           {{rowData.remarks}}
                        </div>

                        <ng-template #emptyComment>
                           <span style="font-family: 'FontAwesome';">
                              No Remarks
                           </span>
                        </ng-template>
                     </td>

                     <td style="text-align: center;">
                        <button pButton type="button" pTooltip="Deactivate Order" tooltipPosition="top"
                           style="margin-right: 5px;" class="p-button-danger p-button" icon="fa fa-times"
                           (click)="deletePurchaseOrder(rowData)">
                        </button>
                        <button pButton type="button" pTooltip="Edit Order Details" tooltipPosition="top"
                           icon="fa fa-pencil-square-o" (click)="viewPurchaseOrder(rowData)" style="margin-right: 5px;">
                        </button>
                     </td>

                  </tr>
               </ng-template>
            </p-table>
         </div>
      </div> -->

   </div>
</div>

<p-dialog [(visible)]="showCommentBox" [closeOnEscape]="true" [focusOnShow]="false"
   [style]="{width: '36vw', left:'570px', top:'288px'}">
   <p-header>
      {{setLabel("purchaseOrderRemarksLabel")}}
   </p-header>
   <form>
      <div style="height: 140px;">
         <div class="p-g-12">
            <div class="p-inputgroup">
               <span class="p-inputgroup-addon"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
               <textarea class="textarea" rows="5" readonly cols="80"
                  style="width: 100%; height: 120px; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;"
                  [(ngModel)]="purchaseOrder.remarks" [placeholder]='setLabel("remarksPlaceholderLabel")'
                  name="body"></textarea>
            </div>
         </div>
      </div>
   </form>
</p-dialog>